import React from 'react';
import { observer } from 'mobx-react';

import PikabuLogo from '../../assets/svg/pikabu.svg';
import partnerLogo from '../../assets/images/logo.png';
import Image from '../UI/Image/Image';

import classes from './header.module.scss';

import { ShareBlock } from '@/components/ShareBlock/ShareBlock';
import { analytics, AnalyticsClick, prepareUrl } from 'src/utils/analytics';
import { useStorage } from '@/models/Storage';

export default observer(function Header() {
    const { result } = useStorage();

    return (
        <header className={`${classes.header}`} suppressHydrationWarning>
            <div className={classes.container}>
                <div className={classes.logoBlock}>
                    <a
                        href={prepareUrl(AnalyticsClick.PikabuLogo)}
                        target={'_blank'}
                        rel={'noopener noreferrer'}
                    >
                        <PikabuLogo className={classes.pikabuLogo} />
                    </a>
                    <ShareBlock foldable result={result} />
                </div>
                <div className={classes.logoBlock}>
                    <a
                        href={prepareUrl(AnalyticsClick.PartnerLogo)}
                        target={'_blank'}
                        rel={'noopener noreferrer'}
                    >
                        <Image src={partnerLogo} className={classes.partnerLogo} />
                    </a>
                </div>
            </div>
        </header>
    );
});
